var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { checkSupport } from "./helpers/checkSupport";
import Factory from "./generated/emscripten/SDLWasmLib.mjs";
import { setupInteractivity } from "./setupInteractivity";
export const init = (_a) => __awaiter(void 0, [_a], void 0, function* ({ assetFolderPath, canvas, preinitializedWebGLContext, verbose = false, onAbort, }) {
    const checkSupportResult = checkSupport();
    // We could throw an exception here. However, then it's up to the client to decide if they
    // handle this properly or not. As this is not in fact an error, but an EXPECTED scenario
    // for ~1% of users according to current browser usage stats, I prefer to handle it with a
    // dedicated response type. This FORCES the consuming client code to think about it and
    // handle it.
    if (!checkSupportResult.all) {
        return {
            unsupportedReason: checkSupportResult,
        };
    }
    const versionedAssetFolderPath = typeof assetFolderPath === "string"
        ? assetFolderPath
        : assetFolderPath("9.2.0-beta.2"); // See inject-version.js
    const module = (yield Factory({
        canvas,
        locateFile: (path) => {
            // We can't use the URL constructor because we want to support relative paths too.
            return versionedAssetFolderPath + "/emscripten/" + path;
        },
        preinitializedWebGLContext,
        print: function (text) {
            if (verbose) {
                console.log(text);
            }
        },
        printErr: function (error) {
            if (verbose || (error && error.toLowerCase().includes("error"))) {
                // Only log actual errors, filter out Ogre initialization messages
                console.error(error);
            }
        },
        onAbort,
    }));
    // For now, we don't have any types for the module itself. Emscripten could generate these.
    // Here we link up Emscripten JS and Djinni TS with a simple cast.
    const application = module.Application;
    const vectorFontsBaseUrl = versionedAssetFolderPath + "/fonts";
    const terrainEngine = module.Application.create(vectorFontsBaseUrl);
    const { cleanupInteractivity } = setupInteractivity(canvas, application);
    const cleanup = () => {
        cleanupInteractivity();
        application.destroy();
    };
    return {
        terrainEngine,
        destroy: cleanup,
        versionInfo: application.getVersionInfo(),
    };
});
// Export all of the generated types and enums so they are available as top-level imports.
// TODO: maybe we don't need to expose all of these to the client?
export * from "./generated/types/activity_content";
export * from "./generated/types/application";
export * from "./generated/types/breadcrumb_recorder";
export * from "./generated/types/camera";
export * from "./generated/types/constants";
export * from "./generated/types/content";
export * from "./generated/types/debug_api";
export * from "./generated/types/engine_configuration";
export * from "./generated/types/gesture_recognizer_contol";
export * from "./generated/types/mre_holder";
export * from "./generated/types/offline";
export * from "./generated/types/osm_filter";
export * from "./generated/types/private_api";
export * from "./generated/types/route_content";
export * from "./generated/types/segments_filter";
export * from "./generated/types/strava_poi_filter";
export * from "./generated/types/structures";
export * from "./generated/types/terrain_engine";
export * from "./generated/types/utils";
export * from "./generated/types/window_lifecycle_listener";
